import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ContractsService } from "../../services/contracts.service";
import { ContractWebLocal } from "../../models";
import { SummaryHeaderComponent } from "src/app/shared/summary-header/summary-header.component";
@Component({
    selector: "app-contracts",
    templateUrl: "./contracts.component.html",
    styleUrls: ["./contracts.component.scss"],
})
export class ContractsComponent implements OnInit, OnDestroy
{

    title = "";
    contractList: ContractWebLocal[];
    contractListSubscription: Subscription;

    constructor(
        private contractsService: ContractsService,
    ) { }

    ngOnInit(): void
    {
        this.contractListSubscription = this.contractsService.contract.subscribe(c => this.contractList = c);

    }

    ngOnDestroy()
    {
        this.contractListSubscription.unsubscribe();
    }

}
